import React from "react";

const validDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const approvalInitials = (name) =>
  String(name || "").trim().split(/\s+/).filter(Boolean)
    .slice(0, 2).map((part) => part[0]).join("").toUpperCase() || "?";

export default function ApprovalPunchSummary({ inDateTime, outDateTime }) {
  const start = validDate(inDateTime);
  const end = validDate(outDateTime);
  const minutes = start && end ? Math.floor((end - start) / 60000) : -1;
  const duration = minutes >= 0 ? `${Math.floor(minutes / 60)}h ${String(minutes % 60).padStart(2, "0")}m` : "—";
  const punch = (date, label) => (
    <div className={`approval-punch-end approval-punch-${label.toLowerCase()}`}>
      <span className="approval-punch-label">{label}</span>
      <strong className="approval-punch-time">{date ? date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false }) : "—"}</strong>
      <span className="approval-punch-date">{date ? date.toLocaleDateString("en-GB", { weekday: "short", day: "2-digit", month: "short" }) : "—"}</span>
    </div>
  );
  return (
    <div className="approval-punch-summary">
      {punch(start, "IN")}
      <div className="approval-punch-path">
        <span className="approval-punch-arrow" aria-hidden="true" />
        <span className="approval-punch-duration" aria-label={`Duration ${duration}`}>{duration}</span>
        <span className="approval-punch-arrow" aria-hidden="true" />
      </div>
      {punch(end, "OUT")}
    </div>
  );
}
